<template>
    <div class="Site PageBox">
      <van-nav-bar
        fixed
        :border="false"
        :title="navBarTitle"
        left-arrow
        @click-left="$router.go(-1)"
      ></van-nav-bar>
      <div class="ScrollBox">
        <!-- <div class="search">
          <div>
            <input type="text" readonly v-model="startDate" @click="showDate=true,currentDate=new Date(startDate),pickType=1">
            -
            <input type="text" readonly v-model="endDate" @click="showDate=true,currentDate=new Date(endDate),pickType=2">
          </div>
          <van-button type="info" size="mini" @click="getTeamReport">{{$t('teamReport.default[0]')}}</van-button>
        </div> -->
        <div class="level-panel">
        <van-row v-if="reportData.groupData" class="level-list" type="flex" justify="space-between">
            <van-col span="24" v-for="(item, index) in reportData.groupData" :key="index">
              <div class="level-card">
                <div class="level-card__header">
                  <span class="level-card__title">{{$t('teamReport.team['+index+']')}}</span>
                  <span class="level-card__arrow" @click="openUser(index)">&gt;</span>
                </div>
                <div class="level-card__body">
                  <div class="level-card__stat">
                    <span class="level-card__count">{{item.userCount || '0'}}</span>
                    <span class="level-card__label">{{$t('teamReport.totalUser')}}</span>
                  </div>
                  <button type="button" class="level-card__btn" @click="openUser(index)">
                    {{$t('teamReport.clickViewTeam')}}
                  </button>
                </div>
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      
      <Footer />
      <van-popup v-model="showDate" position="bottom" close-on-popstate>
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          :title="$t('teamReport.default[16]')"
          :min-date="minDate"
          @confirm="confirmDate"
          @cancel="showDate=false"
        />
      </van-popup>
      <!-- 图标位置 -->
      <van-popup
        v-model="usersShow"
        closeable
        close-icon-position="top-left"
        position="bottom"
        :style="{ height: '100%' }"
      >
      <div style="margin-top: 50px;">
        <van-cell v-if="userList.length>0" :border="false" v-for="(item,index) in userList" :key="index">
          <!-- <div slot="icon">
            <img :src="`./static/images/login/logo.png`" width="40px" height="40px">
          </div> -->
          <template #title>
            <div>
              <span>{{item.username}}</span>
            </div>
          </template>
          <template #label>
            <div>
              <span>{{dayFromat(item.reg_time)}}</span>
            </div>
          </template>
        </van-cell>
        <div v-if="userList.length<1" style="display: flex;justify-content: center; align-items: center;margin-top: 50%;">
          <svg-icon icon-file-name="nomessage" style="font-size: 280px;"></svg-icon>
        </div>
      </div>
      </van-popup>
    </div>
  </template>
  
  <script>
  import dayjs from "dayjs";
  export default {
    name: 'TeamReport',
    components: {
    },
    props: [],
    data() {
      return {
        tabsIndex: 0,
        currentDate: '',
        startDate: this.$Util.DateFormat('YY-MM-DD',new Date().setDate(new Date().getDate())),
        endDate: this.$Util.DateFormat('YY-MM-DD',new Date()),
        showDate: false,
        minDate: new Date(2020,0,1),
        pickType: 1,
        reportData: {
          team1: '',
          team2: '',
          team3: '',
          teamProfit:0
        },
        lowerName: [],
        currPid: '',
        teamActive: 0,
        navBarTitle:'',
        usersShow: false,
        userList:[],
      }
    },
    computed: {
  
    },
    watch: {
  
    },
    created() {
      switch(this.tabsIndex){
        case 1:
          this.navBarTitle = this.$t('teamReport.tabs[1]')
          break;
        default:
          this.navBarTitle = this.$t('teamReport.tabs[0]')
      }
      this.getTeamReport()
      this.$Model.GetUserInfo();
    },
    mounted() { 

    },
    activated() {
  
    },
    destroyed() {
      
    },
    methods: {
      dayFromat(val) {
        console.log(new Date(val));
        return dayjs(val).format("DD/MM/YYYY");
      },
      openUser(index){
        this.usersShow = true;
        this.userList = this.reportData.groupData[index].usersData;
        console.log(this.userList);
      },
      confirmDate(date) {
        if(this.pickType==1){
          this.startDate = this.$Util.DateFormat('YY-MM-DD',date)
        }
        if(this.pickType==2){
          this.endDate = this.$Util.DateFormat('YY-MM-DD',date)
        }
        this.showDate = false
      },
      changeTabs(index){
        switch(index){
          case 1:
            this.$parent.navBarTitle = this.$t('teamReport.tabs[1]')
            break;
          default:
            this.currPid = ''
            this.lowerName = []
            this.$parent.navBarTitle = this.$t('teamReport.tabs[0]')
            this.getTeamReport()
        }
      },
      getSubUser(pid,name) {
        this.lowerName.push({name: name,pve_id: pid})
        this.getMyTeam(pid)
      },
      getTeamReport() {
        let post = {startdate: this.startDate,enddate: this.endDate}
        if(this.currPid){
          post.pve_id = this.currPid
        }
        this.$Model.TeamReport(post,data=>{
          if(data.code==1){
            data.teamData = Object.values(data.teamData)
            this.reportData = data;
          }
        })
      },
      getMyTeam(pid) {
        let post = {pve_id: pid,startdate: this.startDate,enddate: this.endDate}
        this.currPid = pid
        this.$Model.TeamReport(post,data=>{
          if(data.code==1){
            this.reportData.teamData = Object.values(data.teamData)
          }else{
            this.reportData.teamData = []
          }
        })
      },
      lowerReport(pid,index){
        if(pid){
          this.currPid = pid
          if(index!=this.lowerName.length-1){
            this.getMyTeam(pid)
            this.lowerName = this.lowerName.slice(0,index+1);
          }
        }else{
          this.currPid = ''
          this.lowerName = []
          this.getTeamReport()
        }
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .PageBox{
      overflow: hidden;
      padding-bottom: 3.25rem;
    }
  table{
    text-align: center;
    margin-bottom: 20px;
  }
  table tr th{
    padding: 6px 5px;
    background-color: #fff;
    color: #333;
  }
  
  table tr td{
    border: 1px #151d31 solid;
    padding: 10px 5px;
    color: #4087f1;
  }
  table tr td:first-child,table tr td:last-child{
    border-left: 0;
  }
  table tr td em{
    color: #4087f1;
  }
  .search{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
  }
  .search input{
    border: 1px #ddd solid;
    border-radius: 5px;
    width: 110px;
    line-height: 24px;
    text-align: center;
    font-size: 13px;
    color: #333;
  }
  .MyTeam .bar{
    padding: 0 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .MyTeam .bar a{
    color: #888;
  }
  .MyTeam .bar i{
    color: #1989fa;
  }
    .val {
      text-align: center;
      color: #000;
      h2 {
        margin: 10px 0 0 0;
      }
    }
    .ul-one {
      height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  
  .level-panel {
    margin: 10px;
    border-radius: 8px;
    background: #fff;
  }
  .level-list {
    padding: 8px 6px 12px;
  }
  .level-card {
    margin: 0 4px 12px;
    padding: 12px;
    background-color: rgb(244, 245, 247);
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
  .level-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .level-card__title {
    color: #1d1f2c;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.3;
  }
  .level-card__arrow {
    color: var(--theme-color);
    font-size: 18px;
    line-height: 1;
    padding: 2px 6px;
  }
  .level-card__body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 14px 12px;
    background: #fff;
    border-radius: 6px;
  }
  .level-card__stat {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    min-width: 0;
    flex: 1;
  }
  .level-card__count {
    font-size: 22px;
    font-weight: 600;
    line-height: 1.2;
    color: var(--theme-color);
  }
  .level-card__label {
    margin-top: 6px;
    font-size: 13px;
    color: #666;
    line-height: 1.35;
  }
  .level-card__btn {
    flex-shrink: 0;
    align-self: center;
    max-width: 40%;
    min-width: 108px;
    padding: 8px 10px;
    font-size: 12px;
    line-height: 1.4;
    text-align: center;
    color: var(--theme-color);
    background: transparent;
    border: 1px solid var(--theme-color);
    border-radius: 6px;
    white-space: normal;
    word-break: break-word;
  }
  .MyEarnings {
    /deep/.van-grid-item__content {
      color: #333;
      font-size: 1.125rem;
      text-align: center;
      border-radius: 5px;
      border: none;
    }
  }
  /deep/ .van-nav-bar__title{color:#fff}
  /deep/ .van-nav-bar .van-icon{color:#fff !important}
  </style>